import React from 'react';
import { useAuth } from '../../context/AuthContext';
import TicketsListAdmin from './TicketsListAdmin';
import TicketsListCliente from './TicketsListCliente';

export default function TicketsSoporte() {
  const { user } = useAuth();

  if (!user) return null;

  if (user.rol === 'cliente') {
    return <TicketsListCliente />;
  }

  return <TicketsListAdmin />;
}
